import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  createChambaRegistration,
  createPaymentSession,
  createRegistration,
  getPaymentStatus,
} from "./sanawarAPI";

const initialState = {
  lastRegistration: null,
  lastChambaRegistration:null,
  paymentIntent: null,
  paymentStatus: null,
  loading: "idle", // status: 'idle' | 'loading'
  error: null,
};

// Async thunks
export const submitRegistrationAsync = createAsyncThunk(
  "registration/submit",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await createRegistration(payload);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to submit registration");
    }
  }
);

export const submitChambaRegistrationAsync = createAsyncThunk(
  "registration/chambaSubmit",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await createChambaRegistration(payload);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to submit registration");
    }
  }
);

export const createPaymentIntentAsync = createAsyncThunk(
  "registration/createPaymentSession",
  async ({ phone, amount }, { rejectWithValue }) => {
    try {
      const response = await createPaymentSession(phone, amount);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Payment creation failed");
    }
  }
);

export const fetchPaymentStatusAsync = createAsyncThunk(
  "registration/fetchPaymentStatus",
  async ({ linkId }, { rejectWithValue }) => {
    try {
      const response = await getPaymentStatus(linkId);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Payment status fetch failed");
    }
  }
);

// Slice
export const registrationSlice = createSlice({
  name: "registration",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Registration
      .addCase(submitRegistrationAsync.pending, (state) => {
        state.loading = "loading";
        state.error = null;
      })
      .addCase(submitRegistrationAsync.fulfilled, (state, action) => {
        state.loading = "idle";
        state.lastRegistration = action.payload;
      })
      .addCase(submitRegistrationAsync.rejected, (state, action) => {
        state.loading = "idle";
        state.error = action.payload;
      })

       // Registration
      .addCase(submitChambaRegistrationAsync.pending, (state) => {
        state.loading = "loading";
        state.error = null;
      })
      .addCase(submitChambaRegistrationAsync.fulfilled, (state, action) => {
        state.loading = "idle";
        state.lastChambaRegistration = action.payload;
      })
      .addCase(submitChambaRegistrationAsync.rejected, (state, action) => {
        state.loading = "idle";
        state.error = action.payload;
      })

      // Payment Intent
      .addCase(createPaymentIntentAsync.pending, (state) => {
        state.loading = "loading";
        state.error = null;
      })
      .addCase(createPaymentIntentAsync.fulfilled, (state, action) => {
        state.loading = "idle";
        state.paymentIntent = action.payload;
      })
      .addCase(createPaymentIntentAsync.rejected, (state, action) => {
        state.loading = "idle";
        state.error = action.payload;
      })

      // Payment Status
      .addCase(fetchPaymentStatusAsync.pending, (state) => {
        state.loading = "loading";
        state.error = null;
      })
      .addCase(fetchPaymentStatusAsync.fulfilled, (state, action) => {
        state.loading = "idle";
        state.paymentStatus = action.payload;
      })
      .addCase(fetchPaymentStatusAsync.rejected, (state, action) => {
        state.loading = "idle";
        state.error = action.payload;
      });
  },
});

// Selectors
export const selectLastRegistration = (state) => state.registration.lastRegistration;
export const selectChambaLastRegistration = (state) => state.registration.lastChambaRegistration;
export const selectPaymentIntent = (state) => state.registration.paymentIntent;
export const selectPaymentStatus = (state) => state.registration.paymentStatus;
export const selectRegistrationLoading = (state) => state.registration.loading;
export const selectRegistrationError = (state) => state.registration.error;

export default registrationSlice.reducer;
